import React, { useState, useEffect } from "react";
import axios from "axios";
import { Container, Row, Offcanvas } from "react-bootstrap";
import "../Top-up/topup.css";
import qr from "../../images/qr.png";
import Swal from "sweetalert2";
import { faCopy } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { LoaderProvider } from "../loader/LoaderContext";

import { useNavigate } from "react-router-dom";
import { format2 } from "../../utils/money";

function Topup() {
  const [activeTab, setActiveTab] = useState("topup"); // default to 'withdraw' or 'topup'

  const [isMarketFrozen, setIsMarketFrozen] = useState(false);
  const [freezeMessage, setFreezeMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const fetchMarketStatus = async () => {
    setIsLoading(true); // Start loader
    try {
      const Token = localStorage.getItem("user_token");
      const response = await axios.get(
        "https://toptennis.io/api/users/market-status",
        {
          headers: { Authorization: `Bearer ${Token}` },
        }
      );

      // Extract values from the API response
      const { isFrozen, bannerText } = response.data;

      // Update state with both values
      setIsMarketFrozen(isFrozen);
      setFreezeMessage(bannerText || ""); // Ensure it's not undefined
      setIsLoading(false);
    } catch (error) {
      console.error("Error fetching market status:", error);
    } finally {
      setIsLoading(false); // Ensure loader stops after API response
    }
  };

  useEffect(() => {
    fetchMarketStatus();
  }, []);

  const navigate = useNavigate();

  const [players, setPlayers] = useState([]);

  useEffect(() => {
    const fetchPlayersAndMergeData = async () => {
      const Token = localStorage.getItem("user_token");

      try {
        // Decode user ID from token
        const decodedToken = JSON.parse(atob(Token.split(".")[1]));
        const userId = decodedToken._id;

        // Fetch data from API
        const response = await axios.get(
          `https://toptennis.io/api/users/selected-teamlist/${userId}`,
          { headers: { Authorization: `Bearer ${Token}` } }
        );

        if (response.data && response.data.status) {
          const { team, valueDifferences } = response.data;

          // Create a map of valueDifferences by `player_id`
          const valueDifferenceMap = valueDifferences.reduce(
            (acc, valueDifference) => {
              acc[valueDifference.player_id] = valueDifference;
              return acc;
            },
            {}
          );

          // Merge team.players with valueDifferences
          const mergedData = team.players.map((player) => {
            const differenceData = valueDifferenceMap[player._id] || {};

            return {
              ...player,
              currentValue: differenceData.value || player.value, // Value from valueDifferences if available
              valueDifference: differenceData.valueDifference || 0, // Value difference if available
            };
          });

          // Update state with merged data
          setPlayers(mergedData);
          console.log("Merged Data:", mergedData); // Debugging merged data
        } else {
          console.error("Unexpected response format", response.data);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchPlayersAndMergeData();
  }, []);

  const [show1, setShow1] = useState(false);
  const [differenceValue, setDifferenceValue] = useState(0);
  const [playerval, setplayerval] = useState(0);
  const [inPlayValue, setInPlayValue] = useState(0);
  const [credits, setCredits] = useState(0);
  const [withdrawableCredits, setWithdrawableCredits] = useState(0);
  const [userName, setUserName] = useState("");
  const [totalSpent, setTotalSpent] = useState(0);
  const [totalDeposit, setTotalDeposit] = useState(0);

  const handleClose1 = () => setShow1(false);
  const handleShow1 = () => setShow1(true);
  const handleLogout = () => {
    localStorage.removeItem("user_token");
    localStorage.removeItem("fullName");
    localStorage.removeItem("userId");
    localStorage.removeItem("user_isfrozen");
    localStorage.removeItem("email");
    console.log("User logged out successfully.");
    navigate("/");
  };

  const fetchUserValues = async () => {
    const Token = localStorage.getItem("user_token");

    if (Token) {
      const decodedToken = JSON.parse(atob(Token.split(".")[1]));
      const userId = decodedToken._id;

      try {
        // Fetch user in-play values
        const response = await axios.get(
          `https://toptennis.io/api/users/user/in-play-value/${userId}`,
          {
            headers: { Authorization: `Bearer ${Token}` },
          }
        );

        const {
          name,
          credits,
          withdrawableCredits,
          grand_total_value,
          player_value_sum,
          differenceValue,
          latest_inc,
          totalDeposit,
        } = response.data;

        setUserName(name);
        setCredits(credits);
        setWithdrawableCredits(withdrawableCredits);
        setInPlayValue(grand_total_value);
        setTotalSpent(player_value_sum);
        setDifferenceValue(differenceValue);
        setplayerval(latest_inc);
        setTotalDeposit(totalDeposit || 0);
      } catch (error) {
        console.error("Error fetching in-play values:", error);
      }
    }
  };

  useEffect(() => {
    fetchUserValues();
  }, []);

  useEffect(() => {
    if (!isMarketFrozen) {
      fetchUserValues();
    }
  }, [isMarketFrozen]);

  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     fetchUserValues();
  //   }, 1500); // every 15 seconds

  //   return () => clearInterval(interval);
  // }, []);

  const [amount, setAmount] = useState("");
  const [fromWallet, setFromWallet] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [qrData, setQrData] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem("user_token");

    axios
      .get("https://toptennis.io/api/users/getallQrcodes", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        if (res.data && res.data.length > 0) {
          console.log(res.data, "DRGMHJMNKLHY");

          setQrData(res.data[0]); // Use the latest QR data
        }
      })
      .catch((err) => console.error("Failed to load QR data", err));
  }, []);
  const handleSubscribe = async () => {
    if (!email) {
      setMessage("Please enter a valid email.");
      return;
    }

    try {
      const response = await fetch(
        "https://api.convertkit.com/v3/forms/7878458/subscribe",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            api_key: "3bkwOyREXJsvpFPZ5iUAAw",
            email: email,
          }),
        }
      );

      const data = await response.json();
      if (data.subscription) {
        setMessage(
          "Success! Please check your email to confirm your subscription."
        );
        setEmail(""); // Clear input
      } else {
        setMessage(data.message || "Something went wrong.");
      }
    } catch (error) {
      setMessage("Subscription failed. Please try again later.");
      console.error(error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const Token = localStorage.getItem("user_token");

    if (!Token) {
      console.error("User token not found");
      return;
    }

    try {
      // Start loader
      const response = await axios.post(
        "https://toptennis.io/api/users/depositreq",
        {
          amount,
          walletAddress: fromWallet,
        },
        {
          headers: {
            authorization: `Bearer ${Token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data) {
        Swal.fire({
          icon: "success",
          title: "Deposit Request Submitted",
          text: "Your deposit request has been submitted successfully!",
          confirmButtonColor: "#3085d6",
        });

        setAmount("");
        setFromWallet("");
      }
    } catch (error) {
      console.error("Error submitting deposit request:", error);
      // Stop loader
      Swal.fire({
        icon: "error",
        title: "Submission Failed",
        text: "There was an error submitting your deposit request. Please try again.",
        confirmButtonColor: "#d33",
      });
    }
  };

  const handleEmailClick = () => {
    const email = "contact@toptennis.io";
    const subject = "";
    const body = "";
    const url = `https://mail.google.com/mail/?view=cm&to=${email}&su=${encodeURIComponent(
      subject
    )}&body=${encodeURIComponent(body)}`;
    window.open(url, "_blank");
  };

  const [copySuccess, setCopySuccess] = useState(false);
  const handleCopyAddress = async () => {
    if (!qrData || !qrData.walletAddress) return;

    try {
      // Try using the Clipboard API first
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(qrData.walletAddress);
      } else {
        // Fallback for non-secure contexts
        const textArea = document.createElement('textarea');
        textArea.value = qrData.walletAddress;
        textArea.style.position = 'fixed';
        textArea.style.left = '-999999px';
        textArea.style.top = '-999999px';
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();

        try {
          document.execCommand('copy');
        } catch (err) {
          console.error('Fallback: Oops, unable to copy', err);
        }

        textArea.remove();
      }

      setCopySuccess(true);
      setTimeout(() => setCopySuccess(false), 1500);
    } catch (err) {
      console.error('Failed to copy text: ', err);
      // Optionally show an error message to the user
      Swal.fire({
        icon: 'error',
        title: 'Copy Failed',
        text: 'Unable to copy the address. Please try selecting and copying manually.',
        confirmButtonColor: '#3085d6',
      });
    }
  };

  const [topupParagraph, setTopupParagraph] = useState("");
  const [isLoadingParagraph, setIsLoadingParagraph] = useState(true);

  // Add useEffect for fetching top-up paragraph
  useEffect(() => {
    const fetchTopupParagraph = async () => {
      setIsLoadingParagraph(true);
      try {
        const Token = localStorage.getItem("user_token");
        const response = await axios.get('https://toptennis.io/api/users/topupparagraph', {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${Token}`
          }
        });

        console.log('Topup paragraph response:', response.data); // Debug log

        if (response.data && Array.isArray(response.data) && response.data.length > 0 && response.data[0].text) {
          setTopupParagraph(response.data[0].text);
        } else {
          console.error('Invalid response format:', response.data);
          setTopupParagraph('Unable to load top-up information. Please try again later.');
        }
      } catch (error) {
        console.error("Error fetching top-up paragraph:", error);
        setTopupParagraph('Unable to load top-up information. Please try again later.');
      } finally {
        setIsLoadingParagraph(false);
      }
    };

    fetchTopupParagraph();
  }, []);

  // Voucher Reedmption
  const [voucherCode, setVoucherCode] = useState("");
  const [redeemingVoucher, setRedeemingVoucher] = useState(false);
  const handleRedeemVoucher = async () => {
    if (!voucherCode.trim()) {
      Swal.fire({
        icon: "warning",
        title: "Enter voucher code",
        timer: 1500,
        showConfirmButton: false,
      });
      return;
    }

    const Token = localStorage.getItem("user_token");
    if (!Token) return;

    try {
      setRedeemingVoucher(true);

      const res = await axios.post(
        "https://toptennis.io/api/users/redeem-voucher",
        { code: voucherCode },
        {
          headers: {
            Authorization: `Bearer ${Token}`,
            "Content-Type": "application/json",
          },
        }
      );

      Swal.fire({
        icon: "success",
        title: "Voucher redeemed!",
        text: `+${res.data.credits_added} credits added`,
        timer: 2000,
        showConfirmButton: false,
      });

      // Clear input
      setVoucherCode("");

      // Refresh credits immediately
      fetchUserValues();

    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Voucher failed",
        text:
          error.response?.data?.message ||
          "Unable to redeem voucher. Try again.",
      });
    } finally {
      setRedeemingVoucher(false);
    }
  };

  return (
    <>
      {isLoading && (
        <div className="loader-overlay">
          <div className="loader"></div>
        </div>
      )}
      <Container
        className="justify-content-center align-items-center cn"
        // style={{ paddingTop: "160px"}}
      >
        <Row className="w-100 justify-content-center rowdiv">
          <div className="freeze-banner">
            <p>{freezeMessage} </p>
          </div>

          <div className="user-info">
            <button
              variant="light"
              className="d-md-none menu-btn "
              onClick={handleShow1}
            >
              ☰ {/* Hamburger Icon */}
            </button>
            <div className="left-section1 d-flex1">
              <span className="welcome-text">Welcome, {userName}</span>
              <div className="top-navigation d-none d-md-flex">
                <span className="nav-item" onClick={() => navigate("/home")}>
                  Home
                </span>
                <span
                  className="nav-item active"
                  onClick={() => navigate("/profile")}
                >
                  Profile
                </span>
                <span className="nav-item" onClick={() => navigate("/myteam")}>
                  My Team
                </span>
                <span className="nav-item" onClick={() => navigate("/news")}>
                  News
                </span>
                <span className="nav-item" onClick={() => navigate("/faq")}>
                  FAQs
                </span>
                <span className="nav-item" onClick={handleLogout}>
                  Logout
                </span>
              </div>
            </div>

            <Offcanvas show={show1} onHide={handleClose1} placement="start">
              <Offcanvas.Header closeButton>
                <Offcanvas.Title>Menu</Offcanvas.Title>
              </Offcanvas.Header>
              <Offcanvas.Body>
                <div className="mobile-nav">
                  <span
                    className="nav-item "
                    onClick={() => {
                      navigate("/home");
                      handleClose1();
                    }}
                  >
                    Home
                  </span>
                  <span
                    className="nav-item active"
                    onClick={() => {
                      navigate("/profile");
                      handleClose1();
                    }}
                  >
                    Profile
                  </span>
                  <span
                    className="nav-item "
                    onClick={() => {
                      navigate("/myteam");
                      handleClose1();
                    }}
                  >
                    My Team
                  </span>
                  <span
                    className="nav-item"
                    onClick={() => {
                      navigate("/faq");
                      handleClose1();
                    }}
                  >
                    News
                  </span>
                  <span
                    className="nav-item"
                    onClick={() => {
                      navigate("/faq");
                      handleClose1();
                    }}
                  >
                    FAQs
                  </span>
                  <span
                    className="nav-item"
                    onClick={() => {
                      handleLogout();
                      handleClose1();
                    }}
                  >
                    Logout
                  </span>
                </div>
              </Offcanvas.Body>
            </Offcanvas>

            <div className="right-section1">
              <div className="credit-box-container">
                <button
                  className="topup-button"
                  onClick={() => {
                    navigate("/topup");
                  }}
                >
                  Top-up
                </button>
                <div className="credit-box">
                  <p className="p">
                    Credit available: <span>{format2(credits + withdrawableCredits)}</span>
                  </p>
                  <p className="p">
                    Withdrawable Credit: <span>{format2(withdrawableCredits)}</span>
                  </p>
                  <p className="p">
                    In-play: <span>{inPlayValue.toFixed(2)}</span>
                  </p>
                  <p className="p">
                    Current Team P/L:&nbsp;
                    <span
                      style={{
                        color:
                          Number(differenceValue) > 0
                            ? "green"
                            : Number(differenceValue) < 0
                            ? "red"
                            : "black",
                      }}
                    >
                      {differenceValue
                        ? Number(differenceValue) > 0
                          ? `+${Number(differenceValue).toFixed(2)}`
                          : Number(differenceValue).toFixed(2)
                        : "0.00"}
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </Row>
        <div className="top-nav">
          {/* <span className="top-up">Top-up</span>
            <span className="withdraw-selected">Withdraw</span> */}
          <span
            className={`top-up-selected ${
              activeTab === "topup" ? "active" : ""
            }`}
            onClick={() => {
              setActiveTab("topup");
              navigate("/topup");
            }}
          >
            Top-up
          </span>
          <span
            className={`withdraw  ${activeTab === "withdraw" ? "active" : ""}`}
            onClick={() => {
              setActiveTab("withdraw");
              navigate("/withdraw");
            }}
          >
            Withdraw
          </span>
        </div>
        {/* <div className="topup-wrapper">
          <div className="topup-container">
            <div className="left-section">
              <p className="info-text">
                To increase your credit available to buy more shares in players,
                please send USDT to the following wallet address:
              </p>
              <p className="wallet-address">
                0xb7B4edebF6BF3d82bC3d2dB2e5fc2B6179d87660
              </p>
              <p className="info-text">
                Alternatively, you can scan the QR code in your wallet app.
              </p>

              <p className="highlighted">
                <strong>Only send Tether (USDT)</strong> to this address.
                <br />
                This address can only receive Tether (USDT) on the Ethereum
                network.
              </p>

              <p className="warning">
                DO NOT send Tether (USDT) on any other network or it may be
                lost.
              </p>
            </div>

            <div className="qr-section">
              <img src={qr} alt="QR Code" className="qr-image" />
            </div>

            <form className="form-section" onSubmit={handleSubmit}>
              <p className="form-description">
                Please enter the amount you will be sending and your 'from'
                wallet address below so we can track your top-up and assign your
                credits to your account.
              </p>
              <p className="note">
                All deposits will be credited within an hour subject to
                successful receipt of USDT.
              </p>

              <label className="label">Amount</label>
              <div className="input-group">
                <input
                  type="text"
                  className="input1"
                  value={amount}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (/^\d*\.?\d{0,2}$/.test(value)) setAmount(value);
                  }}
                  required
                />
                <span className="conversion">1 USDT = 10 credits</span>
              </div>

              <label className="label">
                Your 'sending from' wallet address
              </label>
              <div className="pt">
                <input
                  type="text"
                  className="input1 full"
                  value={fromWallet}
                  onChange={(e) => setFromWallet(e.target.value)}
                  required
                />

                <button type="submit" className="submit-btnnn">
                  SUBMIT
                </button>
              </div>
            </form>
          </div>
        </div> */}
        <div className="topup-wrapper">
          <div className="topup-container">
            <div className="left-section">
              {isLoadingParagraph ? (
                <p className="info-text">Loading top-up information...</p>
              ) : (
                <p className="info-text">{topupParagraph}</p>
              )}
              {qrData && (
                <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "10px" }}>
                  <p className="wallet-address" style={{ marginBottom: 0 }}>
                    {qrData.walletAddress}
                  </p>
                  <button
                    type="button"
                    onClick={handleCopyAddress}
                    style={{
                      padding: "2px 8px",
                      fontSize: "18px",
                      cursor: "pointer",
                      background: "none",
                      border: "none",
                    }}
                  >
                    <FontAwesomeIcon icon={faCopy} />
                  </button>
                  {copySuccess && (
                    <span style={{ color: "green", fontSize: "12px" }}>
                      Copied!
                    </span>
                  )}
                </div>
              )}

              {qrData ? (
                <div
                  className="info-text"
                  dangerouslySetInnerHTML={{
                    __html:
                      qrData.walletDescription
                        .split("</p>")
                        .slice(0, -3) // all except last 2
                        .join("</p>") + "</p>",
                  }}
                />
              ) : (
                <p>Loading wallet info...</p>
              )}
            </div>

            <div className="qr-section">
              {qrData ? (
                <img
                  src={`https://toptennis.io/api/${qrData.qr_image}`}
                  alt="QR Code"
                  className="qr-image"
                />
              ) : (
                <p>Loading QR code...</p>
              )}
            </div>

            {/* Form */}
            <form className="form-section" onSubmit={handleSubmit}>
              {qrData && (
                <div
                  className="form-description"
                  dangerouslySetInnerHTML={{
                    __html:
                      qrData.walletDescription
                        .split("</p>")
                        .slice(-3) // last 2 paragraphs
                        .join("</p>") + "</p>",
                  }}
                />
              )}

              <label className="label">Amount (in USDT)</label>
              <div className="input-group">
                <input
                  type="text"
                  className="input1"
                  value={amount}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (/^\d*\.?\d{0,2}$/.test(value)) setAmount(value);
                  }}
                  required
                />
                <span className="conversion">1 USDT = 10 credits</span>
              </div>

              <label className="label">
                Your 'sending from' wallet address
              </label>
              <div className="pt">
                <input
                  type="text"
                  className="input1 full"
                  value={fromWallet}
                  onChange={(e) => setFromWallet(e.target.value)}
                  required
                />
                <button type="submit" className="submit-btnnn">
                  SUBMIT
                </button>
              </div>
              {/* ---------------- VOUCHER SECTION ---------------- */}
              <div className="form-section" style={{ marginTop: "10px" }}>
                <p className="form-description">
                  Do you have a voucher code? Enter it below and click Redeem.
                </p>

                <div className="pt">
                  <input
                    type="text"
                    className="input1 full"
                    placeholder="Enter voucher code"
                    value={voucherCode}
                    onChange={(e) =>
                      setVoucherCode(e.target.value.toUpperCase())
                    }
                    disabled={redeemingVoucher}
                  />

                  <button
                    type="button"
                    className="submit-btnnn"
                    onClick={handleRedeemVoucher}
                    disabled={redeemingVoucher}
                  >
                    {redeemingVoucher ? "REDEEMING..." : "REDEEM"}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>

        <div className="card-footer-topup">
          <div className="footer">
            <div className="footer-firstline">
              <div className="footer-sub">
                <h4>Keep in touch</h4>
                <h5>Join our newsletter. We promise not to spam!</h5>
                <input
                  type="email"
                  placeholder="Email Address"
                  className="footer-input"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
                <button className="subscribe-btn" onClick={handleSubscribe}>
                  Subscribe
                </button>
                {message && (
                  <p style={{ marginTop: "10px", marginLeft: "5px" }}>
                    {message}
                  </p>
                )}
              </div>

              <div className="footer-sub1">
                <h4>Quick links</h4>
                <a href="/home" className="footer-link">
                  Home
                </a>
                <a href="/profile" className="footer-link">
                  Profile
                </a>
                <a href="/myteam" className="footer-link">
                  My Team
                </a>
                <a href="/news" className="footer-link">
                  News
                </a>
                <a href="/faq" className="footer-link">
                  FAQs
                </a>
                {/* <a
                  onClick={handleEmailClick}
                  className="footer-link"
                  style={{ cursor: "pointer" }}
                >
                  Support
                </a> */}
              </div>

              <div className="footer-sub1 secondicon">
                <h4>Socials</h4>
                <div className="social-icons">
                  <a
                    href="https://www.facebook.com/toptennisio/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="social-circle"
                    style={{ textDecoration: "none" }}
                  >
                    <i className="fab fa-facebook-f"></i>
                  </a>
                  <a
                    href="https://www.instagram.com/toptennisuk"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="social-circle"
                    style={{ textDecoration: "none" }}
                  >
                    <i className="fab fa-instagram"></i>
                  </a>
                </div>
                <div className="fl1">
                  <a
                    href="/terms"
                    className="footer-link"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    T&Cs
                  </a>
                  <a
                    href="/privacy"
                    className="footer-link"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Privacy Policy
                  </a>
                    <span className="footer-link">
                      Email: contact@toptennis.io
                    </span>
                </div>
              </div>
              {/* </div> */}
            </div>
          </div>
        </div>
      </Container>
    </>
  );
}

export default Topup;
